"use client";
import VerticalSlider from "@/components/ui/VerticalSlider";
import { motion } from "framer-motion";
import { DrupalNode } from "next-drupal";

interface SliderProps {
  data: DrupalNode;
}

function VerticalSliderSection({ data }: SliderProps) {
  const isBlue = data?.field_background_color === "blue";
  const isWhite = data?.field_background_color === "white";
  const isGray = data?.field_background_color === "gray";
  const isDarkDray = data?.field_background_color === "dark_gray";

  const bgClass = isBlue
    ? "bg-[#003350]"
    : isWhite
    ? "bg-white"
    : isGray
    ? "bg-[#f9f9f9]"
    : isDarkDray
    ? "bg-mapGray"
    : "bg-white";

  return (
    <div
      className={`py-[100px] betweenMobileTab:pt-16 betweenMobileTab:pb-24 ${bgClass} relative`}
    >
      <div className="mini-container relative z-[2]">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center text-[32px] mobileMax:text-[28px] font-semibold mobileMax:text-center text-transparent bg-clip-text bg-[linear-gradient(to_top,#316FA8,#003350)] mb-6"
        >
          {data?.field_title}
        </motion.h2>
        <VerticalSlider data={data?.field_add_card} />
      </div>
    </div>
  );
}

export default VerticalSliderSection;
